export default "__VITE_ASSET__BYq7oMtX__"